import { render, staticRenderFns } from "./ShadowComp.vue?vue&type=template&id=7114779d&"
import script from "./ShadowComp.vue?vue&type=script&lang=js&"
export * from "./ShadowComp.vue?vue&type=script&lang=js&"
import style0 from "./ShadowComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports